import { useState } from 'react';
import { faqList } from '@/mocks/faq';
import SchemaOrg from '@/components/feature/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchemaData = {
    mainEntity: faqList.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <SchemaOrg type="FAQPage" data={faqSchemaData} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于漫境，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}